import React from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";



//BKantarci pages
import BKantarciHome from "pages/BKantarciHome";
import BKantarciTeaching from "./pages/BKantarciTeaching";
import BKantarciService from "pages/BKantarciService";
import BKantarciPublications from "./pages/BKantarciPublications";
import BKantarciAwards from "pages/BKantarciAwards";
import BKanatarciResearchGrants from "pages/BKanatarciResearchGrants";


function AppRouter() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/program" element={<Program />} /> */}
        {/* for BKantarci */}
        <Route path="/" element={<BKantarciHome />} />
        <Route path="/teaching" element={<BKantarciTeaching />} />
        <Route path="/service" element={<BKantarciService />} />
        <Route path="/publications" element={<BKantarciPublications />} />
        <Route path="/awards" element={<BKantarciAwards />} />
        <Route path="/research-grants" element={<BKanatarciResearchGrants />} />

      </Routes>
    </Router>
  );
}

export default AppRouter;
